import { Theme, styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)<Theme>(({ theme }) => ({
  fontSize: 24,
  lineHeight: "120%",
  fontWeight: theme.typography.fontWeightBold,
}));
